import { Modal, Button } from "react-bootstrap";
import React from "react";
import "../../modal.css";
import "react-datepicker/dist/react-datepicker.css";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from "axios";
import { useFormik } from "formik";
import * as Yup from "yup";

const severitySchema = Yup.object().shape({     
    name: Yup.string().required("Name is required."),
    min_val: Yup.number()
        .required("Minimum value is required.")
        .typeError("Minimum value must be a number."),
    max_val: Yup.number()
        .required("Maximum value is required.")
        .typeError("Maximum value must be a number.")
        .when("min_val", (min_val, schema) => 
            min_val !== undefined 
                ? schema.min(min_val + 1, "Maximum value must be greater than Minimum value.") 
                : schema
        ),
});


const SeverityLevelForm = ({ mode, showModal, hideModal, initialData, onSuccess }) => {

    const { values, errors, handleChange, handleSubmit, setErrors } = useFormik({
        initialValues: {
            name: initialData.name ?? "",
            min_val: initialData.min_val ?? 0,
            max_val: initialData.max_val ?? 0,
        },
        enableReinitialize: true,
        validationSchema: severitySchema,
        onSubmit: async (values) => {
            try {
                await axios.put(`/severity-levels/${initialData.id}`, values);
                toast.success("Severity level updated successfully.");
                onSuccess();
                hideModal();
            } catch (error) {
                toast.error("Failed to update severity level.");
    
                if (error.response && error.response.data && error.response.data.errors) {mat
                    toast.error(error.response.data.errors);     
                } else if (error.response && error.response.data && error.response.data.message) {
                    toast.error(error.response.data.message);
                }
            }
        },
    });

    return (
        <Modal style={{marginTop: "60px"}} show={showModal} onHide={hideModal} backdrop={false}>
            <Modal.Header closeButton>
                <Modal.Title>Edit Severity Level</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label>Name</label>
                        <input
                            type="text"
                            name="name"
                            className="form-control"
                            value={values.name}
                            onChange={handleChange}
                        />
                        {errors.name && <div className="error">{errors.name}</div>}
                    </div>
                    <div className="form-group">
                        <label>Min Value</label>
                        <input
                            type="number"
                            name="min_val"
                            className="form-control"
                            value={values.min_val}
                            onChange={handleChange}
                        />
                        {errors.min_val && <div className="error">{errors.min_val}</div>}
                    </div>
                    <div className="form-group">
                        <label>Max Value</label>
                        <input
                            type="number"
                            name="max_val"
                            className="form-control"
                            value={values.max_val}
                            onChange={handleChange}
                        />
                        {errors.max_val && <div className="error">{errors.max_val}</div>}
                    </div>
                </form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={hideModal}>
                    Cancel
                </Button>
                <Button variant="primary" type="submit" onClick={handleSubmit}>
                    Save
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default SeverityLevelForm;

